import { defineMessages } from 'react-intl';

export default defineMessages({
    cancelChangeTitle:{
        "id":"certificatesofinsurance.create.Discard Changes",
        "defaultMessage":"Discard Changes"
    },
    cancelChangeMessage:{
        "id":"certificatesofinsurance.create.Are you sure you want to discard your changes?",
        "defaultMessage":"Are you sure you want to discard your changes?"
    },
    Title:{
        "id":"certificatesofinsurance.create.Error entering Input data",
        "defaultMessage":"Input Field Error"

    },
    errorMessage:{
        "id":"certificatesofinsurance.create.Error entering Input message data",
        "defaultMessage":"Please enter all the mandatory fields to proceed further"
    }
});